import React, { useEffect, useState } from 'react'

import { Source } from 'types/GlobalSource'

import Button from 'components_new/atoms/Button'
import TextField from 'components_new/atoms/TextField'

import NumberField from 'components_new/molecules/NumberField'
import SelectSearch from 'components_new/molecules/SelectSearch'
import SimpleDialog from 'components_new/molecules/SimpleDialog'

const PAGINATION_INCREMENT_OPTIONS = [{ title: 'Page', id: 'page' }]

type TPaginationValues = {
  limit: string
  limit_param: string
  pagination_increment: string | null
  start_param: string
}

export type TPaginationParams = {
  limit: number | null
  limit_param: string
  pagination_increment: string | null
  start_param: string
}

interface EditPaginationDialogProps {
  onClose: () => void
  onSubmit: (params: TPaginationParams) => void
  open: boolean
  source: Source
}

const getInitialValues = (source: Source): TPaginationValues => ({
  limit:
    source.attributes.limit !== null ? String(source.attributes.limit) : '',
  limit_param: source.attributes.limit_param ?? '',
  pagination_increment: source.attributes.pagination_increment,
  start_param: source.attributes.start_param ?? ''
})

const EditPaginationDialog = (props: EditPaginationDialogProps) => {
  const { onClose, onSubmit, open, source } = props

  const [values, setValues] = useState<TPaginationValues>(() =>
    getInitialValues(source)
  )

  useEffect(() => {
    if (open) {
      setValues(getInitialValues(source))
    }
  }, [open, source])

  const selectedIncrement =
    PAGINATION_INCREMENT_OPTIONS.find(
      (option) => option.id === values.pagination_increment
    ) ?? null

  return (
    <SimpleDialog
      actions={
        <>
          <Button onClick={onClose} variant="text">
            Avbryt
          </Button>
          <Button
            onClick={() => {
              onSubmit({
                limit: values.limit !== '' ? parseInt(values.limit, 10) : null,
                limit_param: values.limit_param,
                pagination_increment: values.pagination_increment,
                start_param: values.start_param
              })
              onClose()
            }}
          >
            Spara
          </Button>
        </>
      }
      onClose={onClose}
      open={open}
      title="Uppdatera paginering"
    >
      <NumberField
        label="Limit"
        onChange={(value) => setValues({ ...values, limit: value })}
        type="number"
        value={values.limit}
      />
      <TextField
        helperText={
          <>
            Vad heter <i>limit</i> query parametern (ex. limit/count)
          </>
        }
        label="Limit-parameter"
        onChange={(event) =>
          setValues({ ...values, limit_param: event.target.value })
        }
        value={values.limit_param}
      />
      <TextField
        helperText={
          <>
            Vad heter <i>offset</i> query parametern (ex. offset/page_number)
          </>
        }
        label="offset-parameter"
        onChange={(event) =>
          setValues({ ...values, start_param: event.target.value })
        }
        value={values.start_param}
      />
      <SelectSearch
        closeOnSelect={true}
        helperText={
          <>
            Välj <i>Page</i> om paginationen ökar med 1 för varje anrop
          </>
        }
        multiple={false}
        onChange={(increment) =>
          setValues({
            ...values,
            pagination_increment: increment ? increment.id : null
          })
        }
        options={PAGINATION_INCREMENT_OPTIONS}
        placeholder="Välj pagineringstyp..."
        selected={selectedIncrement}
        size="medium"
      />
    </SimpleDialog>
  )
}

export default EditPaginationDialog
